import { HttpService } from '@/utils/http/index'
const $http = new HttpService()

/**
 * 获取管理员列表
*/
export const getAdminList = () => $http.get('/dsapi/trade/channel_sale_user')

/**
 * 获取销售人员列表
*/
export const getSaleList = () => $http.get('/admin/coupons/get_salesman_list')

/**
 * 绑定 wx 账号
*/
export const wxBindApi = () => $http.get('/port/channel/shop_qrcode_img')

// 获取客服人员列表
export const getServiceList = (params:object = {}) => $http.get(`/opsapi/disposeList`, params)